import type { CustomFieldKind, ItemFieldEntry } from '@cheqroom/api';

import type { InfoField } from '../Fields.types';

/**
 * Mirrors {@link resolveSystemFields}: iterates `customFields` (i.e. `fieldDefs`), not `fields`, so
 * a value present on the entity but not selected in `customFields` is never rendered.
 */
export const resolveCustomFields = (
	fields: Record<string, unknown>,
	customFields: ItemFieldEntry[] = []
): InfoField[] =>
	customFields
		.filter((field) => field.id.startsWith('fields.') && field.name in fields)
		.map((field) => ({
			id: field.id,
			value: fields[field.name],
			type: field.editor,
			kind: field.kind as CustomFieldKind | undefined,
		}));
